import type { DividerColors } from '../../../../tokens/colors/types';
import { neutral } from './palette';

export const divider: DividerColors = {
  dotted: neutral[50],
  light: neutral[10],
  default: neutral[70],
};
